import { TrtcClient } from 'utils/trtcClient';
const SET_VIDEO_MUTE_STATUS = 'videoChat/setVideoMuteStatus';
const SET_AUDIO_MUTE_STATUS = 'videoChat/setAudioMuteStatus';
const SET_REMOTE_AUDIO_MUTE_STATUS = 'videoChat/setRemoteAudioMuteStatus';
const SET_REMOTE_VIDEO_MUTE_STATUS = 'videoChat/setRemoteVideoMuteStatus';
const SET_VIDEO_CAMERA_DEVICE = 'videoChat/setVideoCameraDevice';
const SET_SPEAKER = 'videoChat/setSpeaker';
const SET_MICROPHONE = 'videoChat/setMicrophone';
export const setAudioMuteStatus = (muted) => {
    return {
        type: SET_AUDIO_MUTE_STATUS,
        payload: {
            isAudioMuted: muted,
        },
    };
};
export const setVideoMuteStatus = (muted) => {
    return {
        type: SET_VIDEO_MUTE_STATUS,
        payload: {
            isVideoMuted: muted,
        },
    };
};
export const setRemoteAudioMuteStatus = (muted) => {
    return {
        type: SET_REMOTE_AUDIO_MUTE_STATUS,
        payload: {
            isRemoteAudioMuted: muted,
        },
    };
};
export const setRemoteVideoMuteStatus = (muted) => {
    return {
        type: SET_REMOTE_VIDEO_MUTE_STATUS,
        payload: {
            isRemoteVideoMuted: muted,
        },
    };
};
export const setVideoCameraDevice = (cameraId, cameraDeviceLabel) => {
    return {
        type: SET_VIDEO_CAMERA_DEVICE,
        payload: {
            cameraDeviceId: cameraId,
            cameraDeviceLabel,
        },
    };
};
export const setMicrophone = (microphoneId, microphoneLabel) => {
    return {
        type: SET_MICROPHONE,
        payload: {
            microphoneId,
            microphoneLabel,
        },
    };
};
export const setSpeaker = (speakerId, speakerLabel) => {
    return {
        type: SET_SPEAKER,
        payload: {
            speakerId,
            speakerLabel,
        },
    };
};
export const muteRemoteAudio = (muted) => (dispatch) => {
    dispatch(setRemoteAudioMuteStatus(muted));
};
export const muteRemoteVideo = (muted) => (dispatch) => {
    dispatch(setRemoteVideoMuteStatus(muted));
};
export const muteVideo = (mute) => (dispatch) => {
    const trtcClient = TrtcClient.getInstance();
    if (trtcClient) {
        trtcClient.setVideoMute(mute).then(() => {
            dispatch(setVideoMuteStatus(mute));
        });
    }
};
export const muteAudio = (mute) => (dispatch) => {
    const trtcClient = TrtcClient.getInstance();
    if (trtcClient) {
        trtcClient.setAudioMute(mute).then(() => {
            dispatch(setAudioMuteStatus(mute));
        });
    }
};
export const switchVideoCamera = (cameraId, cameraDeviceLabel) => (dispatch) => {
    const trtcClient = TrtcClient.getInstance();
    if (trtcClient && trtcClient.localStream) {
        trtcClient.localStream.switchDevice('video', cameraId).then(() => {
            dispatch(setVideoCameraDevice(cameraId, cameraDeviceLabel));
        });
    }
};
export const switchMicrophone = (microphoneId, microphoneLabel) => (dispatch) => {
    const trtcClient = TrtcClient.getInstance();
    if (trtcClient && trtcClient.localStream) {
        trtcClient.localStream.switchDevice('audio', microphoneId).then(() => {
            dispatch(setMicrophone(microphoneId, microphoneLabel));
        });
    }
};
export const switchSpeaker = (speakerId, speakerDeviceLabel) => (dispatch) => {
    const trtcClient = TrtcClient.getInstance();
    if (trtcClient && trtcClient.remoteStream) {
        trtcClient.remoteStream.setAudioOutput(speakerId).then(() => {
            dispatch(setSpeaker(speakerId, speakerDeviceLabel));
        });
    }
};
const initialState = {
    isAudioMuted: false,
    isVideoMuted: false,
    isRemoteAudioMuted: false,
    isRemoteVideoMuted: false,
    cameraDeviceId: '',
    cameraDeviceLabel: '',
    microphoneId: '',
    microphoneLabel: '',
    speakerId: '',
    speakerLabel: '',
};
export default (state = initialState, action) => {
    switch (action.type) {
        case SET_VIDEO_MUTE_STATUS: {
            return Object.assign(Object.assign({}, state), { isVideoMuted: action.payload.isVideoMuted });
        }
        case SET_AUDIO_MUTE_STATUS: {
            return Object.assign(Object.assign({}, state), { isAudioMuted: action.payload.isAudioMuted });
        }
        case SET_REMOTE_AUDIO_MUTE_STATUS: {
            return Object.assign(Object.assign({}, state), { isRemoteAudioMuted: action.payload.isRemoteAudioMuted });
        }
        case SET_REMOTE_VIDEO_MUTE_STATUS: {
            return Object.assign(Object.assign({}, state), { isRemoteVideoMuted: action.payload.isRemoteVideoMuted });
        }
        case SET_VIDEO_CAMERA_DEVICE: {
            return Object.assign(Object.assign({}, state), { cameraDeviceId: action.payload.cameraDeviceId, cameraDeviceLabel: action.payload.cameraDeviceLabel });
        }
        case SET_SPEAKER: {
            return Object.assign(Object.assign({}, state), { speakerId: action.payload.speakerId, speakerLabel: action.payload.speakerLabel });
        }
        case SET_MICROPHONE: {
            return Object.assign(Object.assign({}, state), { microphoneId: action.payload.microphoneId, microphoneLabel: action.payload.microphoneLabel });
        }
        default: {
            return state;
        }
    }
};
